import Cookies from 'js-cookie'

const AccessTokenKey = 'access_token'
const RefreshTokenKey = 'refresh_token'

export function getAccessToken(): string {
  return Cookies.get(AccessTokenKey)
}

export function removeAccessToken() {
  Cookies.remove(AccessTokenKey)
}

export function setRefreshToken(token: string) {
  localStorage.setItem(RefreshTokenKey, token)
}

export function getRefreshToken(): string {
  return localStorage.getItem(RefreshTokenKey) || ''
}

export function removeRefreshToken() {
  localStorage.removeItem(RefreshTokenKey)
}

export function getCSRF() {
  return Cookies.get('_csrf')
}
